// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pad_AJKVO {
    padding : var( --size-padLarge, 16px )
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@leverege/molten/lib/dataViewers/map/shared/views/LineStyleSelector.css"],"names":[],"mappings":"AAAA;IACI;AACJ","sourcesContent":[".pad {\n    padding : var( --size-padLarge, 16px )\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pad": `pad_AJKVO`
};
export default ___CSS_LOADER_EXPORT___;
